import { useMemo, useState } from 'react';
import { TipsMapType } from '../../BubbleCommon';

export default function useWindowTipsShow({
  tipsMap,
}: {
  tipsMap: TipsMapType;
}) {
  const [show, setShow] = useState(false);

  const tips = useMemo(() => {
    return show ? null : tipsMap;
  }, [show]);

  const onOpen = () => {
    setShow(true);
  };

  const onClose = () => {
    setShow(false);
  };

  return {
    tips,
    onOpen,
    onClose,
  };
}
